import { api } from "@/lib/api";

export const adminMembersApi = {
    list: (params = {}) => api.get("/admin/members", { params }).then((r) => r.data),
    create: (payload) => api.post("/admin/members", payload).then((r) => r.data),
    get: (id) => api.get(`/admin/members/${id}`).then((r) => r.data),
    update: (id, payload) => api.patch(`/admin/members/${id}`, payload).then((r) => r.data),
    delete: (id) => api.delete(`/admin/members/${id}`).then((r) => r.data),
};
